export default "__VITE_ASSET__CxOD5SGV__"